import DebuggerLabel from "./DebuggerLabel";

export default DebuggerLabel;
